/**
 * @module
 */
define('Favorites',["ajaxHelper", "windowModal"], function (ajax) {
  var signIn;
  var res;
  /**
   * Creates a Favorites instance
   * @constructor
   * @param {*} params Page parameters
   */
  var Favorites = function (params) {
    /**
     * @property {*} params Page parameters
     */
    this.params = params;
  };

  /**
   * Initializes the Favorites functionality
   * @method
   */
  Favorites.prototype.init = function () {
    var instance = this;
    const pendingItems = document.cookie.match(new RegExp("pendingSaveItem=([^;]+)"));
    var cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];
    const isLoggedIn = document.querySelector('[data-isloggedin="True"]');

    if (cookieFavorites) {
      for (let index = cookieFavorites.length - 1; index >= 0; index -= 1) {
        const favoriteString = cookieFavorites[index];
        const favoriteObject = JSON.parse(favoriteString);
        const saveElements = document.querySelectorAll("#" + favoriteObject.element);

        if (isLoggedIn) {
          for (let element of saveElements) {
            Favorites.prototype.updateStylesToSaved(element.dataset.category, favoriteObject.id, element);
          }

          let element = document.querySelector("#" + favoriteObject.element);
          if (!element) {
            element = {
              dataset : favoriteObject.dataset
            }
          }
          instance.removeFromCookie(cookieFavorites, favoriteObject.id);
          instance.saveToFavs(element, favoriteObject.category, favoriteObject.type, favoriteObject.id, favoriteObject.url, favoriteObject.name);
        }
      }
    }

    // On Click Save to Favorites
    var favUnsaveHandler = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.classList.contains("nhs_favLogin")) {
        return false;
      }

      instance.saveToFavs(this, this.dataset.category, this.dataset.type, this.dataset.id, this.dataset.url, this.dataset.name);
      return false;
    };
    Array.from(document.querySelectorAll(".nhs_favUnsave, .nhs_nbyFavUnsave")).forEach(function (favUnsave) {
      favUnsave.addEventListener("click", favUnsaveHandler);
      favUnsave.classList.add("nhs_noLink");
    });

    var favSavedHandler = function (event) {
      event.preventDefault();
      event.stopPropagation();

      var link = this;
      var category = this.dataset.category;

      if (link.classList.contains("nhs_favLogin")) {
        Favorites.prototype.updateStylesToUnsaved(category, link);
        return;
      }

      ajax.request({
        type: "POST",
        url: instance.params.urlBase + "/favorites/delete",
        data: {
          id: this.dataset.favid
        },
        success: function (data) {
          if (!data.Saved) return;

          Favorites.prototype.updateStylesToUnsaved(category, link);
          document.body.dispatchEvent &&
            document.body.dispatchEvent(new CustomEvent("trackIdentifySaveItems", {
              detail: { data: link }
            }));
        }
      });
      return false;
    };

    Array.from(document.querySelectorAll(".nhs_favSaved, .nhs_nbyFavUnsaved")).forEach(function (favSaved) {
      favSaved.addEventListener("click", favSavedHandler);
      favSaved.classList.add("nhs_noLink");
    });

    var mouseDownHandler = function (event) {
      Favorites.prototype.temporalSaveToFavorites.call(this, event);
    };

    Array.from(document.querySelectorAll(".nhs_favLogin")).forEach(function (favLogin) {
      favLogin.addEventListener((dataLayer[0].adaptiveTemplate === "M") ? "click" : "mousedown", mouseDownHandler);
      favLogin.classList.add("nhs_noLink");
    });

    // Save property when param is presented (after login)
    if (location.search.toLowerCase().indexOf("addtoprofile=true") > -1) {
      var favUnsave = document.querySelector(".nhs_favUnsave, .nhs_nbyFavUnsave");
      if (favUnsave) {
        favUnsave.click();
      }

      var url = document.location.href;
      var urlparts = url.split("?");

      if (urlparts.length >= 2) {
        var urlBase = urlparts.shift();
        var queryString = urlparts.join("?");
        var prefix = encodeURIComponent("addtoprofile") + "=";
        var pars = queryString.split(/[&;]/g);

        for (var i = pars.length; i-- > 0;) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1);
          }
        }

        url = urlBase + "?" + pars.join("&");
      }

      window.history.replaceState({}, document.title, url);
    }


    if (dataLayer[0].adaptiveTemplate === "M") {

      document.addEventListener("updateSavesWhenLoggedIn",
        function () {
          var onResLoaded = function () {
            const pendingItems = document.cookie.match(new RegExp("pendingSaveItem=([^;]+)"));
            var cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];

            if (cookieFavorites) {
              for (let index = cookieFavorites.length - 1; index >= 0; index -= 1) {
                const favoriteString = cookieFavorites[index];
                const favoriteObject = JSON.parse(favoriteString);
                let element = document.querySelector("#" + favoriteObject.element);
                instance.removeFromCookie(cookieFavorites, favoriteObject.id);
                instance.saveToFavs(element,
                  favoriteObject.category,
                  favoriteObject.type,
                  favoriteObject.id,
                  favoriteObject.url,
                  favoriteObject.name);
              }
            };

            var element = document.querySelector("[id^=nhs_SaveItem]"); 
            ajax.request({
              type: "POST",
              url: instance.params.urlBase + "/favorites/isSavedToFavorites",
              data: {
                id: element.dataset.id,
                type: element.dataset.type
              },
              success: function(data) {
                if (!data) return;

                if (data.result) {
                  Favorites.prototype.updateStylesToSaved(element.dataset.type.toLowerCase(), data, null);
                }
              }
            });
          }

          const saveElements = document.querySelectorAll("[id^=nhs_SaveItem], [id^=nhs_SavedItem]");

          for (let element of saveElements) {
            element.classList.remove("nhs_favLogin");
          }

          if (!res) {
            require(["i18n!nls/res"],
              function (_res) {
                res = _res;
                onResLoaded();
              });
          } else {
            onResLoaded();
          }
        });
      document.addEventListener("updateSavesWhenLoggedOut",
        function () {
          var saveButtons = document.querySelectorAll("[id^=nhs_SaveItem], [id^=nhs_SavedItem]");

          for (let button of saveButtons) {
            button.classList.add("nhs_favLogin");
            Favorites.prototype.updateStylesToUnsaved(button.dataset.category, button);
          }
        });
    };
  };

  Favorites.prototype.removeFromCookie = function (items, id) {
    const itemIndex = items.map(function (item) { return JSON.parse(item).id; }).indexOf(id);

    if (itemIndex >= 0) {
      items.splice(itemIndex, 1);
      const cookie = ["pendingSaveItem", '=', JSON.stringify(items), '; domain=.', window.location.host.toString(), '; path=/;'].join('');
      document.cookie = cookie;
    }

    return itemIndex >= 0;
  };

  Favorites.prototype.temporalSaveToFavorites = function (event) {
    const pendingItems = document.cookie.match(new RegExp("pendingSaveItem=([^;]+)"));
    const temporalSavedItems = pendingItems ? JSON.parse(pendingItems[1]) : [];

    event.preventDefault();

    const isAlreadyPendingFavorite = temporalSavedItems.some(itemStr => JSON.parse(itemStr).id === this.dataset.id);
    if (!isAlreadyPendingFavorite) {
      temporalSavedItems.push(JSON.stringify({
        element: this.id,
        category: this.dataset.category,
        type: this.dataset.type,
        id: this.dataset.id,
        url: this.dataset.url,
        name: this.dataset.name,
        dataset: this.dataset
      }));

      const cookie = ["pendingSaveItem", '=', JSON.stringify(temporalSavedItems), '; domain=.', window.location.host.toString(), '; path=/;'].join('');
      document.cookie = cookie;
    }

    require(['handlerAuth0'],
      function(handlerAuth0) {
        var options = {};
        handlerAuth0.init(options);
      });
  };

  Favorites.prototype.updateStylesToSaved = function (category, data, link) {
    if (category === "" || category === "mainviewer" || category === "commheader" || !link) { // not comm results
      Array.from(document.querySelectorAll(".nhs_favSaved, .nhs_nbyFavUnsaved")).forEach(function (favSaved) {
        favSaved.style.display = "block";
        favSaved.dataset.favid = data.Id;
      });

      Array.from(document.querySelectorAll(".nhs_favUnsave, .nhs_nbyFavUnsave")).forEach(function (favUnSaved) {
        favUnSaved.style.display = "none";
        favUnSaved.dataset.favid = data.Id;
      });
      return;
    }

    if (link && link instanceof HTMLElement) { // results pages                    
      const nextElement = link.parentElement.querySelector(".nhs_favSaved, .nhs_nbyFavUnsaved");

      if (nextElement) {
        nextElement.dataset.favid = data.Id;
        nextElement.style.display = "block";
      }

      link.style.display = "none";
    }
  },

    Favorites.prototype.updateStylesToUnsaved = function (category, link) {
      if (category === "" || category === "mainviewer" || category === "commheader") {
        Array.from(document.querySelectorAll(".nhs_favSaved, .nhs_nbyFavUnsaved")).forEach(function (favSaved) {
          favSaved.style.display = "none";
          favSaved.removeAttribute("data-favid");
        });

        Array.from(document.querySelectorAll(".nhs_favUnsave, .nhs_nbyFavUnsave")).forEach(function (favSaved) {
          favSaved.style.display = "block";
        });

        return;
      }

      if (link) {
        link.style.display = "none";
        delete link.dataset.favid;

        if (link.previousElementSibling) {
          link.previousElementSibling.style.display = "block";
        }
      }
    };
  /**
   * Saves an element to favorites
   * @method
   * @param {String} link Link
   * @param {String} category Favorite category
   * @param {String} type Favorite type
   * @param {String} id Favorite id
   * @param {String} url Url
   * @param {String} name Favorite name
   */
  Favorites.prototype.saveToFavs = function (link, category, type, id, url, name) {
    var instance = this;

    if (typeof (instance.params.logInfo) === "undefined") {
      instance.params.logInfo = {
        marketId: instance.params.marketId,
        partnerId: instance.params.partnerId
      };

      if (category === "homeresults" && type === "HomePlan") {
        instance.params.logInfo.planId = id;
      } else if (category === "homeresults" && type === "HomeSpec") {
        instance.params.logInfo.specificationId = id;
      } else {
        instance.params.logInfo.communityId = id;
      }
    }

    instance.logEvents(category, type, id);

    ajax.request({
      type: "POST",
      url: instance.params.urlBase + "/favorites/save",
      data: {
        Type: type,
        Id: id,
        FavoriteUrl: url,
        Title: name
      },
      success: function (data) {
        if (!data.Saved) return;
        Favorites.prototype.updateStylesToSaved(category, data, link);
        document.body.dispatchEvent &&
          document.body.dispatchEvent(new CustomEvent("trackIdentifySaveItems", {
            detail: { data: link }
          }));
      }
    });
  };

  /**
   * Logs events
   * @method
   * @param {String} category Favorite category
   * @param {String} type Favorite type
   * @param {String} id Favorite id
   */
  Favorites.prototype.logEvents = function (category, type, id) {
    var instance = this;
    var log = instance.params.logger || instance.params.logInfo;

    if (category === "commheader") {
      log.googlepush("Community Detail Events", "Community - Gallery", "Save to favorites");
      log.logEventWithParameters("CDSTC", instance.params.logInfo);
    } else if (category === "commfooter") {
      log.googlepush("Community Detail Events", "Community - Next Steps", "Save to favorites");
      log.logEventWithParameters("CDNSSTF", instance.params.logInfo);
    } else if (category === "mpcheader") {
      log.googlepush("Community Detail Events", "Master Plan Community - Header", "Save to favorites");
      logger.logEventWithParameters("Save_Listing", instance.params.logInfo);
    } else if (category === "mpcfooter") {
      log.googlepush("Community Detail Events", "Master Plan Community - Next Steps", "Save to favorites");
      log.logEventWithParameters("Save_Listing", instance.params.logInfo);
    } else if (category === "homeheader") {
      log.googlepush("Home Detail Events", "Home - Gallery", "Save to favorites");
      log.logEventWithParameters("HOMSTC", instance.params.logInfo);
    } else if (category === "homefooter") {
      log.googlepush("Home Detail Events", "Home - Next Steps", "Save to favorites");
      log.logEventWithParameters("HDNSSTF", instance.params.logInfo);
    } else if (category === "mainviewer") {
      log.googlepush("Image Viewer", "Image Viewer", "Image Viewer - Favorite");
      if (type === "Community") {
        log.logEventWithParameters("CDSTC", instance.params.logInfo);
      } else {
        log.logEventWithParameters("HOMSTC", instance.params.logInfo);
      }
    } else if (category === "homesgrid") {
      var homeLogInfo = instance.params.logInfo;
      if (type === "HomePlan") {
        homeLogInfo.planId = id;
      } else if (type === "HomeSpec") {
        homeLogInfo.specId = id;
      }
      log.googlepush("Image Viewer", "Image Viewer", "Image Viewer - Homes Favorite");
      log.logEventWithParameters("HOMSTC", homeLogInfo);
    } else if (category === "commresults") {
      log.googlepush("Community Results Events", "Community Item", "Save to favorites");
      log.googlepush("Search Events", "Search Results", "Favorite Community");
      log.SetDataLayerPair("favoriteSaved");
      log.logEventWithParameters("SAVETOFAV_CR", instance.params.logInfo);
    } else if (category === "homeresults") {
      log.googlepush("Community Results Events", "Home Item", "Save to favorites");
      log.logEventWithParameters("SAVETOFAV_HR", instance.params.logInfo);
    } else if (category === "builder") {
      log.googlepush("Builder Showcase Events", "Builder Showcase", "Save to favorites");
      log.logEventWithParameters("SAVETOFAV_BSC", instance.params.logInfo);
    }
  };

  return Favorites;
});
